import { useState } from "react";
import axios from "axios";

export default function AddContactForm({ fetchContacts, token, API_BASE_URL }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const addContact = async () => {
    if (!name || !email || !phone) {
      setError("All fields are required.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `${API_BASE_URL}/contacts/`,
        { name, email, phone },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchContacts();
      setName("");
      setEmail("");
      setPhone("");
      setError("");
    } catch (err) {
      setError("Failed to add contact.");
    }
    setLoading(false);
  };

  return (
    <div>
      <h2>Add a New Contact</h2>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="tel"
        placeholder="Phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />
      <button onClick={addContact} disabled={loading}>
        {loading ? "Adding..." : "Add Contact"}
      </button>
      {error && <p className="text-danger">{error}</p>}
    </div>
  );
}
